import { AiseaApiFactory } from "@/api/aisea/apiFactory";

// 役職ポジションの表示・非表示設定リポジトリ
const enterpriseManningVesselRolePostionsDisplayRepository = AiseaApiFactory.get(
  "enterpriseManningVesselRolePostionsDisplay"
);

const CrewFilterService = (() => {
  /**
   * 役職ポジションの表示・非表示設定を更新する
   * @param {*} data
   * @returns
   */
  const putManningVesselRolePositionDisplay = async data => {
    const res = await enterpriseManningVesselRolePostionsDisplayRepository.update(
      data
    );
    if (!res || !res.status) {
      throw res;
    }
    return res.data;
  };

  const createFilterData = (resourceData, manningVessel) => {
    const rolePositions = manningVessel.manning_vessels.flatMap(vessel => {
      return vessel.manning_vessel_roles.flatMap(role =>
        role.manning_vessel_role_positions.map(position => ({
          id: position.id,
          name: position.name,
          display_in_manning_table: position.display_in_manning_table,
        }))
      );
    });

    const listData = [];
    let idx = 0;
    resourceData.forEach(resource => {
      if (!resource.children) {
        return;
      }

      resource.children.forEach(child => {
        if (child.required) {
          return;
        }

        const rolePosition = rolePositions.find(
          position => position.id === child.id.split("_")[1]
        );
        if (rolePosition) {
          listData.push({
            id: child.id,
            name: child.name,
            visible: rolePosition.display_in_manning_table,
            groupName: resource.name,
            groupId: `g_${idx}`,
          });
        }
      });
      idx++;
    });

    return listData;
  };

  return { createFilterData, putManningVesselRolePositionDisplay };
})();

export { CrewFilterService };
